<template>
  <main role="main" class="container py-5">
    <b-button @click="onClickTest">Test loading modal</b-button>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class TestLoadingModal extends BaseComponent {

    mounted() {

    }

    onClickTest() {
      this.showLoading();
      setTimeout(this.hideLoading, 2000);
    }

  }
</script>
